export type SupportedChatLocale = 'de' | 'en'

export const SHOP_PHONE = '+43 1 341 9185'
export const SHOP_EMAIL = 'office@stamm-baum.at'

export const CHAT_ERROR_FALLBACK: Record<SupportedChatLocale, string> = {
  de: 'Entschuldigung, der Assistent ist gerade nicht erreichbar. Bitte versuche es erneut oder kontaktiere uns per Telefon (+43 1 341 9185) oder E-Mail (office@stamm-baum.at).',
  en: 'Sorry, the assistant is currently unavailable. Please try again or contact us by phone (+43 1 341 9185) or email (office@stamm-baum.at).',
}

export const CHAT_RETRY_BUTTON_LABEL: Record<SupportedChatLocale, string> = {
  de: '↻ Erneut versuchen',
  en: '↻ Try again',
}

export const CHAT_RETRY_BUTTON_ARIA: Record<SupportedChatLocale, string> = {
  de: 'Letzte Nachricht erneut senden',
  en: 'Retry last message',
}

export const CHAT_ERROR_MESSAGES: Record<SupportedChatLocale, Record<string, string>> = {
  de: {
    upstream_unavailable: CHAT_ERROR_FALLBACK.de,
    upstream_timeout: CHAT_ERROR_FALLBACK.de,
    non_json_response: CHAT_ERROR_FALLBACK.de,
    internal_error: CHAT_ERROR_FALLBACK.de,
    UPSTREAM_ERROR: CHAT_ERROR_FALLBACK.de,
    UPSTREAM_BUSY: CHAT_ERROR_FALLBACK.de,
    TIMEOUT: CHAT_ERROR_FALLBACK.de,
    INTERNAL_ERROR: CHAT_ERROR_FALLBACK.de,
    empty_response:
      'Der Assistent konnte keine Antwort generieren. Das passiert manchmal bei sehr langen Unterhaltungen oder sensiblen Themen — formuliere deine Frage bitte anders oder starte eine neue Unterhaltung.',
    EMPTY_RESPONSE:
      'Der Assistent konnte keine Antwort generieren. Das passiert manchmal bei sehr langen Unterhaltungen oder sensiblen Themen — formuliere deine Frage bitte anders oder starte eine neue Unterhaltung.',
  },
  en: {
    upstream_unavailable: CHAT_ERROR_FALLBACK.en,
    upstream_timeout: CHAT_ERROR_FALLBACK.en,
    non_json_response: CHAT_ERROR_FALLBACK.en,
    internal_error: CHAT_ERROR_FALLBACK.en,
    UPSTREAM_ERROR: CHAT_ERROR_FALLBACK.en,
    UPSTREAM_BUSY: CHAT_ERROR_FALLBACK.en,
    TIMEOUT: CHAT_ERROR_FALLBACK.en,
    INTERNAL_ERROR: CHAT_ERROR_FALLBACK.en,
    empty_response:
      'The assistant could not generate a response. This can happen with very long conversations or restricted topics — try rephrasing or starting a new conversation.',
    EMPTY_RESPONSE:
      'The assistant could not generate a response. This can happen with very long conversations or restricted topics — try rephrasing or starting a new conversation.',
  },
}

export function getChatErrorMessage(
  code: string | undefined | null,
  locale: string = 'de'
): string {
  const normLocale: SupportedChatLocale = locale === 'en' ? 'en' : 'de'
  if (!code) {
    return CHAT_ERROR_FALLBACK[normLocale]
  }
  const messages = CHAT_ERROR_MESSAGES[normLocale]
  return messages[code] || CHAT_ERROR_FALLBACK[normLocale]
}
